import DocumentJsonPreviewDrawer from '@modules/ComposedDocument/materials/drawers/DocumentJsonPreviewDrawer.vue';

export default {
	DocumentJsonPreviewDrawer,
};
